import { getNeutralOrganColorVariant } from '@repo/ui';
import useFeature from 'services/features/useFeature';
import useCurrentKitAndTinyAccount from './useCurrentKitAndTinyAccount';

/**
 * The current kit's inputs to the gut body map and its organ badges. `colorVariant`
 * is the baby-neutral colour; surfaces that set their own colour ignore it.
 */
export const useGutBodyProps = () => {
  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const { isFeatureEnabled: isBabyNeutralColorEnabled } = useFeature(
    'neutral_color_for_baby_body_component',
  );

  const age = currentKit?.age_at_sampling ?? 0;
  const pregnant = !!currentKit?.pregnant;

  return {
    age,
    pregnant,
    sex: currentTinyAccount?.sex ?? 'M',
    colorVariant: getNeutralOrganColorVariant({
      age,
      pregnant,
      enabled: isBabyNeutralColorEnabled,
    }),
  };
};

export default useGutBodyProps;
